import { render, staticRenderFns } from "./LoadingOnboarding.vue?vue&type=template&id=5cd39ed8&scoped=true&"
import script from "./LoadingOnboarding.vue?vue&type=script&lang=ts&"
export * from "./LoadingOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingOnboarding.vue?vue&type=style&index=0&id=5cd39ed8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd39ed8",
  null
  
)

export default component.exports